import { User } from '@auth0/auth0-spa-js';

export class BiddingUser extends User {
  isPublisher(user: User): boolean {
    return user['J+ Bidding/roles']?.includes('bidding-publisher') || false;
  }
}
